module.exports = __webpack_public_path__ + "static/media/door0301.717f0f86.jpg";